import { IonIcon, IonItem, IonLabel } from '@ionic/react';
import { useLocation } from 'react-router-dom';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { ReminderBadge } from '../components/badge/ReminderBadge.tsx';
import { NewFeatureBadge } from '../components/badge/NewFeatureBadge.tsx';
import { MenuViewModel } from './MenuViewModel.ts';
import { Color } from '../components/common/index.ts';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    menuItem: {
        '&::part(native)': {
            minHeight: 32,
            height: '5vh',
            maxHeight: 40
        }
    }
});

interface MenuItemProps {
    title: string;
    small?: boolean;
    bold?: boolean;
    url?: string;
    otherUrls?: string[];
    reminderCount?: number;
    icon?: any;
    onClick?: () => void;
    newFeatureKey?: string;
    newFeatureLabel?: string;
    color?: Color;
};

export const MenuItem: React.FC<MenuItemProps> = ({ title, small = false, bold = false, url, otherUrls = [], onClick, reminderCount = 0, icon, color, newFeatureKey, newFeatureLabel }) => {
    const fontWeight = (bold ? 'bold' : undefined);
    const fontSize = (small ? 17 : 18);

    const classes = useStyles();

    const menuVM = useInstance(MenuViewModel);

    const location = useLocation();
    const isSelected = ([url, ...otherUrls].some(path => location.pathname?.startsWith(path!)));

    return (
        <IonItem
            style={{'--background': isSelected ? 'rgba(var(--ion-color-primary-rgb), 0.2)' : 'inherit'}}
            className={`${classes.menuItem} ${isSelected ? 'selected' : ''}`}
            routerLink={url}
            routerDirection="none"
            lines="none"
            detail={false}
            button // controls cursor/hover
            onClick={menuVM.clickHandler(onClick)}
        >
            <div style={{position: 'relative', padding: '0 4px'}} slot="start" title={title}>
                <IonIcon
                    style={{pointerEvents: 'none', fontSize: (small ? 22 : 24), minWidth: 24, paddingTop: 5}}
                    color={color || (isSelected ? 'primary' : 'medium')}
                    icon={icon?.raw}
                />
                {reminderCount > 0 &&
                    <div style={{position: 'absolute', top: -2, right: -7}}>
                        <ReminderBadge size="small" count={reminderCount} />
                    </div>
                }
            </div>

            <IonLabel color={color} style={{margin: 0, fontSize, fontWeight}}>{title}</IonLabel>

            {newFeatureKey &&
                <NewFeatureBadge slot="end" featureKey={newFeatureKey} label={newFeatureLabel} />
            }
        </IonItem>
    );
};
